import React, { useState } from 'react';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import PlayButton from 'assets/images/Play-Button-S.png';
import { Image } from 'components/atoms/image';
import { HTMLView } from 'components/atoms/htmlView';
import TUIG from '../../../assets/images/TUIG.png';
//eslint-disable-next-line
import styles from "./styles.scss";

const TestimonialCard = props => {
  const { data, mediaPath, imagePath, sectionType } = props;
  const [showVideoLayout, setShowVideoLayout] = useState(false);
  const mediaUrl = `${mediaPath}${data.web}`;
  const videoMediaUrl = data.video_thumbnail ? data.video_thumbnail : TUIG;
  const thumbnailUrl =
    sectionType === 'videos'
      ? data.video_thumbnail
      : `${mediaPath}${data.thumbnail}/${imagePath}`;

  const showOverlay = showVideoLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={data.url_video}
        theme={'dark-theme'}
        type={'video-overlay'}
        className={'testimonialVideoOverlay'}
        onClosePress={() => setShowVideoLayout(false)}
        breadcrumbList={[]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'image_card'}>
      <Image
        thumbNail={thumbnailUrl}
        className={'testimonial-image'}
        src={
          sectionType === 'videos' ? videoMediaUrl : `${mediaUrl}/${imagePath}`
        }
        alt={'videos'}
      />
      <div
        className={
          sectionType === 'videos' ? 'card-intro videos' : 'card-intro'
        }
      >
        <h1 className={'testimonial-name'}>{data.name}</h1>
      </div>
      <div className={'intro_testimonial'}>
        <div className={'intro-text'}>
          {data.project_name && (
            <span className={'testimonial_project_name'}>
              {data.project_name}
            </span>
          )}
          <HTMLView
            html={data.description}
            tagName={'h4'}
            className={
              sectionType === 'videos'
                ? 'testimonial-description videos'
                : 'testimonial-description'
            }
          />
        </div>
        {!data.url_video ? (
          ''
        ) : (
          <button
            onClick={() => setShowVideoLayout(true)}
            className={'play-button'}
          >
            <img
              src={PlayButton}
              alt={'PlayButton'}
              className={'play-button-img'}
            />
          </button>
        )}
      </div>
      {showOverlay}
    </div>
  );
};
export default TestimonialCard;
